<div class="container">
    <app-risk-flow-risk-assesment 
    [config]="{
      consumerId: 'GC',
      flow: 'CWP',
      clientType: 'CLIENT'
    }"
    (resultHandler)="resultHandler($event)"
    (errorHandler)="errorHandler($event)">
    </app-risk-flow-risk-assesment>
    <vgim-secure-link></vgim-secure-link>
</div>